import gql from 'graphql-tag'

export const consoleQrCodesByInstallation = gql`
  query QrCodesByInstallation(
    $installationId: ID!
    $page: Int
    $pageSize: Int
    $status: String
    $search: String
  ) {
    consoleQrCodesByInstallation(
      installationId: $installationId
      page: $page
      pageSize: $pageSize
      status: $status
      search: $search
    ) {
      items {
        id
        code
        plate
        status
        validFrom
        validUntil
        entryScannedAt
        exitScannedAt
        createdAt
      }
      total
      page
      pageSize
      totalPages
      stats {
        total
        active
        used
        expired
        revoked
      }
    }
  }
`
